// Convert Israeli phone numbers from 972 format to 052-5521108 format
// Example: 972525521108 => 052-5521108
function normalizePhoneNumber(phone) {
  if (!phone) return "";
  // Remove all non-digit characters
  let digits = String(phone).replace(/\D/g, "");
  // Remove country code if present
  if (digits.startsWith("972")) {
    digits = digits.slice(3);
  }
  // Add leading zero
  if (!digits.startsWith("0")) {
    digits = "0" + digits;
  }
  // Format as 3 digits, dash, then the rest
  if (digits.length > 3) {
    digits = digits.slice(0, 3) + "-" + digits.slice(3);
  }
  return digits;
}

export default normalizePhoneNumber;
